module.exports = __webpack_public_path__ + "media/slivo.26ff04c3.wav";